import React from "react";
import { useNavigate } from "react-router-dom";

const ProfileCard = ({ user, onEnable2FA }) => {
    const navigate = useNavigate();

    if (!user) return null;

    return (
        <div className="bg-white shadow-lg rounded-xl p-6 w-full max-w-md mx-auto">
            <div className="flex flex-col items-center">
                <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center text-4xl font-bold text-blue-600 mb-4">
                    {user.name?.[0]?.toUpperCase() || "?"}
                </div>

                <h3 className="text-xl font-semibold mb-1">
                    {user.name} {user.lastName}
                </h3>

                <p className="text-gray-500 text-sm">{user.email}</p>

                <p className="text-gray-600 mt-2">
                    <span className="font-bold">Role:</span> {user.role || "User"}
                </p>

                <p className="mt-2">
                    <span className="font-bold">2FA:</span>{" "}
                    {user.isTwoFactorEnabled ? (
                        <span className="text-green-600 font-medium">Enabled</span>
                    ) : (
                        <span className="text-red-600 font-medium">Disabled</span>
                    )}
                </p>

                <button
                    onClick={() => navigate("/client-form")}
                    className="mt-4 bg-indigo-600 text-white px-4 py-2 rounded-lg shadow hover:bg-indigo-700 transition"
                >
                    Edit Client Data
                </button>

                {!user.isTwoFactorEnabled && (
                    <button
                        onClick={onEnable2FA}
                        className="mt-3 bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                    >
                        Enable 2FA
                    </button>
                )}
            </div>
        </div>
    );
};

export default ProfileCard;